import { render, staticRenderFns } from "./page-comingsoon.vue?vue&type=template&id=5cbe6ada&"
import script from "./page-comingsoon.vue?vue&type=script&lang=js&"
export * from "./page-comingsoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports